import { Group, GroupType, ProcedureType, ProcedureTypesDescriptions } from '@pages/my-procedures/model/procedure-types.model';
import { ProcedureCodes } from '@core/domain/model/procedures/procedure-codes';

import { MyProceduresRouteNames } from '@pages/my-procedures/my-procedures-route-names';

export const groups: Array<GroupType> = [
  { type: Group.INVOICE, desc: 'PROCEDURES.GROUPS.INVOICE' },
  { type: Group.CONTRACT, desc: 'PROCEDURES.GROUPS.CONTRACT' },
  { type: Group.COMPLAINT, desc: 'PROCEDURES.GROUPS.COMPLAINT' },
];

export const spanishProcedureTypesActions: Array<ProcedureType> = [
  {
    icon: 'tools',
    title: ProcedureTypesDescriptions.CONCEPTS_DISCREPANCY,
    route: MyProceduresRouteNames.CONCEPTS_DISCREPANCY,
    code: ProcedureCodes.CONCEPTS_DISCREPANCY,
    group: Group.COMPLAINT,
  },
  {
    icon: 'tools',
    title: ProcedureTypesDescriptions.POWER_DISCREPANCY,
    route: MyProceduresRouteNames.POWER_DISCREPANCY,
    code: ProcedureCodes.POWER_DISCREPANCY,
    group: Group.COMPLAINT,
  },
  {
    icon: 'tools',
    title: ProcedureTypesDescriptions.MEASUREMENT_DISCREPANCY,
    route: MyProceduresRouteNames.MEASUREMENT_DISCREPANCY,
    code: ProcedureCodes.MEASUREMENT_DISCREPANCY,
    group: Group.COMPLAINT,
  },
  {
    icon: 'fair_price',
    title: ProcedureTypesDescriptions.INVOICE_CONCEPT,
    route: MyProceduresRouteNames.INVOICE_CONCEPT,
    code: ProcedureCodes.INVOICE_CONCEPT,
    group: Group.INVOICE,
  },
  {
    icon: 'energy_certificate',
    title: ProcedureTypesDescriptions.ACCOUNT_CHANGE,
    route: MyProceduresRouteNames.ACCOUNT_CHANGE,
    code: ProcedureCodes.ACCOUNT_CHANGE,
    group: Group.CONTRACT,
  },
  {
    icon: 'fair_price',
    title: ProcedureTypesDescriptions.INVOICE_ADDRESS_CHANGE,
    route: MyProceduresRouteNames.INVOICE_ADDRESS_CHANGE,
    code: ProcedureCodes.INVOICE_ADDRESS_CHANGE,
    group: Group.INVOICE,
  },
  {
    icon: 'energy_certificate',
    title: ProcedureTypesDescriptions.CANCELLATION,
    route: MyProceduresRouteNames.CANCELLATION,
    code: ProcedureCodes.CANCELLATION,
    group: Group.CONTRACT,
  },
  {
    icon: 'energy_certificate',
    title: ProcedureTypesDescriptions.POWER_TARIFF_CHANGE,
    route: MyProceduresRouteNames.POWER_TARIFF_CHANGE,
    code: ProcedureCodes.POWER_TARIFF_CHANGE,
    group: Group.CONTRACT,
  },
  {
    icon: 'fair_price',
    title: ProcedureTypesDescriptions.PAYMENT_DEFERMENT,
    route: MyProceduresRouteNames.PAYMENT_DEFERMENT,
    code: ProcedureCodes.PAYMENT_DEFERMENT,
    group: Group.INVOICE,
  },
  {
    icon: 'tools',
    title: ProcedureTypesDescriptions.OUTAGES_FAILURES,
    route: MyProceduresRouteNames.OUTAGES_FAILURES,
    code: ProcedureCodes.OUTAGES_FAILURES,
    group: Group.COMPLAINT,
  },
  {
    icon: 'fair_price',
    title: ProcedureTypesDescriptions.INVOICE_DELAY,
    route: MyProceduresRouteNames.INVOICE_DELAY,
    code: ProcedureCodes.INVOICE_DELAY,
    group: Group.INVOICE,
  },
  {
    icon: 'tools',
    title: ProcedureTypesDescriptions.MEASUREMENT_FILE_INCIDENCE,
    route: MyProceduresRouteNames.MEASUREMENT_FILE_INCIDENCE,
    code: ProcedureCodes.MEASUREMENT_FILE_INCIDENCE,
    group: Group.COMPLAINT,
  },
  {
    icon: 'energy_certificate',
    title: ProcedureTypesDescriptions.SELF_CONSUMPTION_CHANGE,
    route: MyProceduresRouteNames.SELF_CONSUMPTION_CHANGE,
    code: ProcedureCodes.SELF_CONSUMPTION_CHANGE,
    group: Group.CONTRACT,
  },
  {
    icon: 'energy_certificate',
    title: ProcedureTypesDescriptions.HOLDER_CHANGE,
    route: MyProceduresRouteNames.HOLDER_CHANGE,
    code: ProcedureCodes.HOLDER_CHANGE,
    group: Group.CONTRACT,
  },
];

export const portugueseProcedureTypesActions: Array<ProcedureType> = [
  {
    icon: 'tools',
    title: ProcedureTypesDescriptions.PORTUGAL_OUTAGES_FAILURES,
    route: MyProceduresRouteNames.PORTUGAL_OUTAGES_FAILURES,
    code: ProcedureCodes.PORTUGAL_OUTAGES_FAILURES,
    group: Group.COMPLAINT,
  },
  {
    icon: 'energy_certificate',
    title: ProcedureTypesDescriptions.PORTUGAL_HOLDER_CHANGE,
    route: MyProceduresRouteNames.PORTUGAL_HOLDER_CHANGE,
    code: ProcedureCodes.PORTUGAL_HOLDER_CHANGE,
    group: Group.CONTRACT,
  },
  {
    icon: 'energy_certificate',
    title: ProcedureTypesDescriptions.PORTUGAL_ACCOUNT_CHANGE,
    route: MyProceduresRouteNames.PORTUGAL_ACCOUNT_CHANGE,
    code: ProcedureCodes.PORTUGAL_ACCOUNT_CHANGE,
    group: Group.CONTRACT,
  },
  {
    icon: 'fair_price',
    title: ProcedureTypesDescriptions.PORTUGAL_CHANGE_BILLING_CONTACTS,
    route: MyProceduresRouteNames.PORTUGAL_CHANGE_BILLING_CONTACTS,
    code: ProcedureCodes.PORTUGAL_CHANGE_BILLING_CONTACTS,
    group: Group.INVOICE,
  },
  {
    icon: 'fair_price',
    title: ProcedureTypesDescriptions.PORTUGAL_INVOICE_CONCEPT,
    route: MyProceduresRouteNames.PORTUGAL_INVOICE_CONCEPT,
    code: ProcedureCodes.PORTUGAL_INVOICE_CONCEPT,
    group: Group.INVOICE,
  },
  {
    icon: 'tools',
    title: ProcedureTypesDescriptions.PORTUGAL_MEASUREMENT_FILE_INCIDENCE,
    route: MyProceduresRouteNames.PORTUGAL_MEASUREMENT_FILE_INCIDENCE,
    code: ProcedureCodes.PORTUGAL_MEASUREMENT_FILE_INCIDENCE,
    group: Group.COMPLAINT,
  },
  {
    icon: 'tools',
    title: ProcedureTypesDescriptions.PORTUGAL_POWER_DISCREPANCY,
    route: MyProceduresRouteNames.PORTUGAL_POWER_DISCREPANCY,
    code: ProcedureCodes.PORTUGAL_POWER_DISCREPANCY,
    group: Group.COMPLAINT,
  },
  {
    icon: 'fair_price',
    title: ProcedureTypesDescriptions.PORTUGAL_INVOICE_DELAY,
    route: MyProceduresRouteNames.PORTUGAL_INVOICE_DELAY,
    code: ProcedureCodes.PORTUGAL_INVOICE_DELAY,
    group: Group.INVOICE,
  },
  {
    icon: 'energy_certificate',
    title: ProcedureTypesDescriptions.PORTUGAL_CANCELLATION,
    route: MyProceduresRouteNames.PORTUGAL_CANCELLATION,
    code: ProcedureCodes.PORTUGAL_CANCELLATION,
    group: Group.CONTRACT,
  },
  {
    icon: 'energy_certificate',
    title: ProcedureTypesDescriptions.PORTUGAL_POWER_CHANGE,
    route: MyProceduresRouteNames.PORTUGAL_POWER_CHANGE,
    code: ProcedureCodes.PORTUGAL_POWER_CHANGE,
    group: Group.CONTRACT,
  },
  {
    icon: 'energy_certificate',
    title: ProcedureTypesDescriptions.PORTUGAL_CYCLE_CHANGE,
    route: MyProceduresRouteNames.PORTUGAL_CYCLE_CHANGE,
    code: ProcedureCodes.PORTUGAL_CYCLE_CHANGE,
    group: Group.CONTRACT,
  },
];
